import api from '../utils/api'

export const getDadosComplementares = (data) => {
  return api.get(process.env.VUE_APP_DADOSCOMPLEMENTARES_API + '?cpf=' + data)
}